<template>
    <div class="fullcontainer p3bg5">
      <Back2FirstPage picposcls="picpos" />
      <MusicIcon picposcls="musicpos" />

      <div class="centerdiv">
        <img class="bg" src="res/p3/hg.png?1">

        <video v-show="state==0" ref="video" class="video" src="res/video/4hg.mp4" :poster="`res/video/4hg.jpg${qver}`" controls preload @pause="onPause" @play="onPlay">
          您的浏览器不支持 video 标签。
        </video>

        <img v-show="state>0" class="hg-1" src="res/p3/hg-1.png">
        <img v-show="state>0" class="hdt" src="res/p3/hdt.png">
        <img v-show="state>0" class="hdt-1" src="res/p3/hdt-1.png" :style="{transform: 'scaleX('+0.9*progress+')'}">
        <img v-show="state>0" class="hdan" src="res/p3/hdan.png" :style="{left: LEFT_MIN+(LEFT_MAX-LEFT_MIN)*progress+'%'}" @touchstart="onSliderTouchStart" @touchend="onSliderTouchEnd" @touchmove="onSliderTouchMove">       
        <!-- <img class="hdthh" src="res/p3/hdthh.png"> -->

        <AnimatePlayer v-show="state>0" animateKey="hg" />
        <AnimatePlayer v-show="state==2" class="hgyw" animateKey="hgyw" />

        <img class="leftbtn heartpulse" src="res/p3/ksp.png" @click="watchVideo">
        <img class="rightbtn" src="res/p3/xiyb.png" @click="$root.$emit('P3SwitchTo','P3_6')">
      </div>

      
    </div> 
</template>

<script>

import { qver } from "@/d";
import Back2FirstPage from "./Back2FirstPage";
import MusicIcon,{getExtends} from "./MusicIcon";
import AnimatePlayer from "./AnimatePlayer";

const components = { Back2FirstPage, MusicIcon,AnimatePlayer };
export default {
  data() {
    return {
      progress:0, // 0 - 1
      LEFT_MIN:23,
      LEFT_MAX:65,
      state : 1, // 0 视频 1 待机 2 冒烟
      qver,
    };
  },

  mounted() {
    // window.console.log("mounted。。。");
    this.state = 1;
    this.ywshow = false;
  },

  methods: {
    onSliderTouchStart(){
      // let img = e.target;
      // window.console.log("start:", img.style.left);
    },
    onSliderTouchEnd(){
      // let img = e.target;
      // window.console.log("end:", img.style.left);
      // window.console.log("温度达到...",this.progress);
      if(this.progress>0.70 && this.progress<0.93) {
         this.state = 2;
        // this.$root.$emit('P3SwitchTo','P3_6');
      }
    },
    onSliderTouchMove(e){
      let t = e.changedTouches[0];
      // let img = e.target;
      let left_num = t.pageX/window.screen.width*100-5;
      if(left_num<this.LEFT_MIN || left_num>this.LEFT_MAX) {
        return;
      }
      let progress = (left_num - this.LEFT_MIN)/(this.LEFT_MAX - this.LEFT_MIN);
      // img.style.left = left_num+'%';
      // window.console.log("move:", t.pageX, t.screenX, window.screen.width);
      this.progress = progress;
    },
    watchVideo(){
      this.state = 0;
      let video = this.$refs.video;
      video.play();
    },
  },

  components,
  extends: getExtends(),
};
</script>

<style lang="scss">
@import "D:/workspace/all_web/src/_cmm/css/centerbg.scss";
@import "D:/workspace/all_web/src/_cmm/css/horizontalCenterPercent.scss";

.p3bg5 {
  // @include centerbg; //'res/p1/bg.png'
  // background: url("../../public/res/p1/bg.png");
  .hg-1 {
    width: 44%;
    right: 14%;
    top:2.5rem;
  }
  $top:6rem;
  .hdt{
    @include horizontalCenterPercent(60%);
    top:$top;
  }
  .hdt-1{
    @include horizontalCenterPercent(50.5%);
    top:$top + 0.3rem;
    transform-origin: 0 50%;
  }
  .hdan{
    top:$top+0.15rem;
    width: 10%;
    // left: 65%;  // 23%  65
  }
  .xyr {
    width: 48%;
    left: 4%;
    top: 2.2rem;
  }
  .hgyw.xyr {
    width: 60%;
    left: 30%;
    top: 2.3rem;
  }
}
</style>
